import { defineStore } from "pinia";
import type { Ref } from "vue";
import { ref } from "vue";

interface ModalState {
	visible: boolean;
	context?: unknown;
}

export const useModalStore = defineStore("modals", () => {
	const list = new Map<string, Ref<ModalState>>();

	const open = (modalName: string, context?: ModalState["context"]) => {
		const modal = state(modalName).value;
		modal.visible = true;
		modal.context = context;
	};
	const close = (modalName: string) => {
		const modal = state(modalName).value;
		modal.visible = false;
	};

	const state = (modalName: string) => {
		if (!list.has(modalName)) list.set(modalName, ref({ visible: false }));

		return list.get(modalName)!;
	};

	return { state, open, close };
});
